export const SocialInfos = [
  {
    id: 1,
    socialTitle: "LinkedIn",
    icon: "https://cdn-icons-png.flaticon.com/512/145/145807.png",
    username: "@shizanvasim",
    socialLink: "https://www.linkedin.com/in/shizanvasim/"
  },
  {
    id: 2,
    socialTitle: "Instagram",
    icon: "https://cdn-icons-png.flaticon.com/512/174/174855.png",
    username: "@therealshizan",
    socialLink: "https://www.instagram.com/therealshizan/"
  },
  {
    id: 3,
    socialTitle: "Twitter",
    icon: "https://cdn-icons-png.flaticon.com/512/124/124021.png",
    username: "@therealshizan17",
    socialLink: "https://twitter.com/therealshizan17"
  },
  {
    id: 4,
    socialTitle: "Gmail",
    icon: "https://cdn-icons-png.flaticon.com/512/5968/5968534.png",
    username: "therealshizan@gmail.com",
    socialLink: "mailto:therealshizan@gmail.com"
  },
  {
    id: 5,
    socialTitle: "GitHub",
    icon: "https://cdn-icons-png.flaticon.com/512/25/25231.png",
    username: "@therealshizan",
    socialLink: "https://github.com/therealshizan/"
  },
];
